<template>
  <div class="mc-delivery-track-sidebar-accordion-item">
    <div header-tag="header" role="tab">
      <div v-b-toggle.accordion-1 class="d-flex justify-content-between">
        <h5>{{ 'Referensi Pengiriman' }}</h5>
        <div>
          <i class="mc-fa icon-fill_arrow-ios-down"></i>
          <i class="mc-fa icon-fill_arrow-ios-up"></i>
        </div>
      </div>
    </div>
    <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
      <div class="mc-delivery-track-sidebar-delivery-info">
        <b-row>
          <b-skeleton-wrapper :loading="isLoading">
            <template #loading>
              <b-skeleton />
            </template>
            <b-col v-if="data?.aju_number != null && data?.aju_number !== ''" cols="6" md="6">
              <div>
                <span class="text-muted">{{ 'No. Aju' }}</span>
                <p>{{ data?.aju_number }}</p>
              </div>
            </b-col>
          </b-skeleton-wrapper>
          <b-skeleton-wrapper :loading="isLoading">
            <template #loading>
              <b-skeleton />
            </template>
            <b-col
              v-if="data?.shipment_number != null && data?.shipment_number !== ''"
              cols="6"
              md="6"
            >
              <div>
                <span class="text-muted">{{ 'No. Shipment' }}</span>
                <p>{{ data?.shipment_number }}</p>
              </div>
            </b-col>
          </b-skeleton-wrapper>
        </b-row>
        <b-row>
          <b-skeleton-wrapper :loading="isLoading">
            <template #loading>
              <b-skeleton />
            </template>
            <b-col
              v-if="data?.reference_number != null && data?.reference_number !== ''"
              cols="6"
              md="6"
            >
              <div>
                <span class="text-muted">{{ 'No. Referensi' }}</span>
                <p>{{ data?.reference_number }}</p>
              </div>
            </b-col>
          </b-skeleton-wrapper>
        </b-row>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isLoading() {
      return this.loading
    },
  },
}
</script>
